<template>

</template>

<script>
  import { setIdToken, setAccessToken } from '../../utils/auth'

  export default {
    name: '',
    mounted () {
      this.$nextTick(() => {
        setAccessToken()
        setIdToken()
        window.location.href = '/summary'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// callback.vue?4bcefbc4